import { render } from "./RoomsSearch.vue?vue&type=template&id=0782fff4"
import script from "./RoomsSearch.vue?vue&type=script&lang=js"
export * from "./RoomsSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\swing_vue_chat\\chat_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__